var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleFilledWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7334 12.7732C13.1267 12.1732 13.2734 11.8665 13.5734 11.1932C11.36 10.3532 11.0067 7.19983 13.1934 5.99316C12.5267 5.15316 11.5867 4.6665 10.7 4.6665C10.06 4.6665 9.62004 4.83318 9.22671 4.98651C8.89338 5.11318 8.59338 5.2265 8.22005 5.2265C7.82005 5.2265 7.46671 5.09985 7.09338 4.96651C6.68671 4.81985 6.26004 4.6665 5.72671 4.6665C4.73338 4.6665 3.67338 5.27317 3.00004 6.31317C2.05338 7.77984 2.22005 10.5265 3.74671 12.8732C4.29338 13.7132 5.02671 14.6532 5.98005 14.6665C6.38005 14.6732 6.64004 14.5532 6.92671 14.4265C7.25338 14.2798 7.60671 14.1198 8.22671 14.1198C8.84671 14.1132 9.19338 14.2798 9.52004 14.4265C9.80004 14.5532 10.0534 14.6732 10.4467 14.6665C11.4134 14.6532 12.1867 13.6132 12.7334 12.7732Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5603 1.3335C10.667 2.06683 10.367 2.7935 9.97362 3.30017C9.55362 3.84684 8.82029 4.27349 8.11362 4.24683C7.98695 3.54016 8.31362 2.81349 8.71362 2.32682C9.16029 1.79349 9.91362 1.38016 10.5603 1.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleFilledWhite);
export default __webpack_public_path__ + "static/media/AppleFilledWhite.7370405ff9884d1be5ff2dc83729a26f.svg";
export { ForwardRef as ReactComponent };